<template>
	<div >
		<maskBox v-loading = 'loading' element-loading-background="rgba(0, 0, 0, 0.1)">
			<div class="exportInner" >
				<p class="innerTitle">导出报表</p>
				<el-form :model="exportD" :rules="ruleForm" ref="ruleForm" label-position="right">
					<el-form-item class="lineClass"  label='导出页码数：' prop="page">
						<span class="right">第</span>
						<el-input  v-model="exportD.page"></el-input>
						<span>页</span>
					</el-form-item>
					<el-form-item class="lineClass" label='导出页大小：' prop="size">
						<span class="right">每页</span>
						<el-input v-model="exportD.size" @input="sizeInput"></el-input>
						<span>条</span>
					</el-form-item>
					<el-form-item class="lineClass" label='导出文件名：'prop="fileName">
						<el-input class='nameClass' v-model="exportD.fileName"></el-input>
					</el-form-item>
				</el-form>
				<div class="bottomArea">
					<el-button class="base-medium-btn" @click="closeMask">关闭</el-button>
					<el-button class="base-medium-btn" type="primary" @click="surExport">确认导出</el-button>
				</div>
			</div>
		</maskBox>
		
	</div>
</template>

<script>
	export default {
		props: {
			type: {
				//1是导出发票,2是导出财务报表
				type: Number,
				default: 0,
			},
			show: {
				type: Boolean,
				default: false,
			},
			searchData:{
				type: Object,
				default: {},
			},
			routerFrom:{
				type: String,
				default: '',
			}
		},
		data() {
			return {
				loading:false,
				ruleForm:{
					page:[{
						required:true,
						message:'请输入页码'
					}],
					size:[{
						required:true,
						message:'请输入页大小'
					}],
					fileName:[{
						required:true,
						message:'请输入文件名'
					}]
				},
				exportD: {
					//导出报表信息
					page: 1,
					size: 1000,
					fileName:''
				},
			};
		},
		mounted() {
			let curDate = this.publicMethed.formatDateTime(new Date())
			let name = ''
			switch(this.type){
				case 0:
					name = '待开票'
					break
				case 1:
					name = '已开票'
					break
				case 2:
					name = '财务报表'
					break
				case 3:
					name = '已出函'
					break
				case 4:
					name = '开票失败'
					break
				case 5:
					name = '开票中'
					break
			}
			this.$set(this.exportD,'fileName', name+curDate )
		},
		methods: {
      // 导出数量限制
      sizeInput(e){
        // console.log(e)
        if(e*1 > 10000){
          this.exportD.size = 1000;
          this.$alert("每页导出最多10000条","提示",{
            type:"warning"
          });
        }
      },
			// 导出报表（后台导出）
			surExport() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						let tem = ''
						if (this.area.brcId == null || this.area.brcId == '000000_000000_000000') {
							tem = null
						} else {
							let brcId = this.area.brcId.split('_')
							if(brcId.length < 3){
								tem = brcId[brcId.length -1]
							}else{
								tem = brcId[2] == '000000' ? (brcId[1] == '000000' ? brcId[0] : brcId[1]) : brcId[2]
							}
						}
						
						let data = {
							page: this.exportD.page,
							size: this.exportD.size,
							type: this.type,
						};
						data ['bcrId'] = tem
						this.loading = true
						if ([0, 1, 4, 5].indexOf(this.type) !== -1) {
							// data['status'] = this.type
							data['isExprot'] = 1
							if(this.userInfo.userType !=2){
								data["invoiceApplyId"] = this.userInfo.enterpriseId;
							}else{
								data["guaranteeId"] = this.userInfo.enterpriseId;
							}
							
							data = Object.assign(this.searchData,data)
							this.requestAPI.queryRecord(data).then((res) => {
								
								this.loading = false
								if(typeof res.data == 'string'){
									let temData = this.publicMethed.base64ToFile(res.data,'application/octet-stream')
									
									this.publicMethed.saveFileToLocal(temData.url,this.exportD.fileName +'.xlsx')
									this.closeMask()
									return 
								}
								
							}).catch(()=>{
								
								this.loading = false
							})
						} else if (this.type == 2) {
							data["guaranteeId"] = this.userInfo.enterpriseId;
							for(let key in this.searchData){
								if(this.searchData[key] !== ''){
									data[key] = this.searchData[key] 
								}
							}
							// data = Object.assign(this.searchData, data)
							this.requestAPI.excelDerive(data).then((res) => {
								
								this.loading = false
								let result = this.publicMethed.base64ToFile(res.data, "application/octet-stream");
								
								this.publicMethed.saveFileToLocal(result.url, this.exportD.fileName +'.xlsx');
								this.closeMask()
							}).catch(()=>{
								
								this.loading = false
							})
						} else if (this.type == 3) {
							for(let key in this.searchData){
								if(this.searchData[key] !== ''){
									data[key] = this.searchData[key] 
								}
							}
							this.requestAPI.exportOrderMessage(data).then((res) => {
								this.loading = false
								let result = this.publicMethed.base64ToFile(res.data, "application/octet-stream");
								this.publicMethed.saveFileToLocal(result.url, this.exportD.fileName +'.xlsx');
								this.closeMask()
							}).catch(()=>{
								this.loading = false
							})
						}
					}
				})
			},
			// 关闭报表弹窗
			closeMask() {
				this.$emit("update:show", false);
			},
		},
	};
</script>

<style lang="less" scoped>
	.exportInner {
		background-color: white;
		border-radius: 5px;
		// height: 300px;
		min-width: 400px;
		padding: 0 40px;

		.innerTitle {
			text-align: center;
			line-height: 70px;
			font-weight: 600;
		}

		.lineClass {
			display: flex;
			flex-direction: row;
			line-height: 60px;

			/deep/ .el-input {
				margin: 0 10px;
				width: 70px;
			}

			/deep/ .el-input__inner {
				text-align: center;
			}

			.innerLeft {
				min-width: 100px;
				text-align: end;
			}
			.pageClass{
				/deep/ .el-form-item__content{
					min-width: 150px;
					    text-align: center;
				}
			}
			.nameClass{
				width: 250px;
				text-align: left;
				/deep/ .el-input__inner{
					text-align: left;
				}
			}
			.right {
				width: 35px;
				text-align: end;
			}
		}

		.bottomArea {
			margin: 20px 0;
			text-align: center;
		}
	}
</style>
